.shadow-style-white {
  box-shadow:
    0 22px 25px 0 var(--shadow-white),
    0 9px 23px 0 var(--shadow-white);

  &:hover.hover {
    box-shadow:
      0 22px 32px 0 var(--shadow-white),
      0 9px 28px 0 var(--shadow-white);
  }
}
